import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { LocalStorageActions } from "../../Redux-Reducer/LocalStorageReducer";
/** Styles Import */
import "./Style.css";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
import TranslationService from "../../Services/Translation/TranslationService";
/** Components Import */
import { Form, Button, Alert } from "react-bootstrap";
import Business from "./Business";
import Worker from "./Worker";
import Loading from "../../Components/Loading";
import swal from "../../Components/SweetAlert2";
import Dialog from "../../Components/Dialog";
import AutoTranslate from "../../Components/AutoTranslate";
/** Icons Import */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateRight } from "@fortawesome/free-solid-svg-icons";

function LoginMobile() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const timerRef = useRef(null);
  const authorization = useSelector((state) => state.localStorage.authorization);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const hasTokenParam = searchParams.has("token");

    if (hasTokenParam) {
      const tokenValue = searchParams.get("token");
      if (tokenValue !== null && tokenValue.trim() !== "") {
        setTimeout(() => {
          Search(tokenValue);
        }, 2000);
      } else {
        setError("유효하지 않은 토큰입니다.");
        setTimeout(() => {
          navigate("/");
        }, 2000);
      }
    } else {
      setError("토큰이 제공되지 않았습니다.");
      setTimeout(() => {
        navigate("/");
      }, 2000);
    }
  }, [location.search, navigate]);

  const Search = async (_param) => {
    try {
      await IndexedDb.ClearTable("UserInfo");
      await Commons.Axios("get", Global.base.useUrl + Global.urls.Account.checkSession, { loginSessionId: _param }).then(async (result) => {
        let data = result.data;
        console.log("Search: ", data);
        if (!data) {
          throw new Error("QR 생성 실패");
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          if (data.status === "AUTHORIZED") {
            await Submit(data.token);
          } else {
            setError("토큰 인증에 실패했습니다. " + _param + " " + data.status + " " + data.message);
            setTimeout(() => {
              // navigate("/");
            }, 2000);
          }
        }
      });
    } catch (e) {
      console.log("Search error: ", e);
    } finally {
    }
  };

  const Submit = async (_param) => {
    try {
      setLoading(true);
      setError(null);

      await IndexedDb.ClearTable("UserInfo");

      const result = await Commons.Axios("get", Global.base.useUrl + Global.urls.Account.refreshToken, {
        token: _param,
        fcmToken: "WEB",
      });

      let data = result.data;
      console.log("Submit1: ", data);

      if (!data) {
        throw new Error("RefreshToken 실패");
      } else if (data.type === "Error") {
        throw new Error(data.message);
      }

      // 국적 코드 조회
      const response = await Commons.Axios("get", Global.base.useUrl + Global.urls.Common.notAuthGetCode, {
        code: "NATIONALITY",
      });
      console.log("response nationality: ", response.data);

      if (response.status === 200 && Array.isArray(response.data)) {
        response.data.forEach((item) => {
          if (item.code === data.userInfo.nationality) {
            dispatch(LocalStorageActions.setLanguage(item));
            Commons.Storages("set", "language", item);
          }
        });
      }

      // 사용자 정보를 IndexedDB에 저장
      await IndexedDb.AddItem("UserInfo", [
        {
          token: data.userInfo.token,
          userId: data.userInfo.userId,
          userNm: data.userInfo.userNm,
          eMail: data.userInfo.eMail,
          photoUrl: data.userInfo.photoUrl,
          birth: data.userInfo.birth,
          bloodType: data.userInfo.bloodType,
          concent: data.userInfo.concent === true,
          profileImage: data.userInfo.photoUrl,
          gender: data.userInfo.gender,
          tel: data.userInfo.tel,
          points: data.userInfo.points,
          address1: data.userInfo.address1,
          address2: data.userInfo.address2,
          validaty: data.userInfo.validaty,
          refreshToken: data.userInfo.refreshToken,
          nationality: data.userInfo.nationality,
          language: data.userInfo.language,
          id: data.userInfo.id,
          guidId: data.userInfo.guidId,
          expiredTime: data.userInfo.expiredTime,
          connTime: Commons.DateFormating(new Date(), 1),
          auth: data.auth,
        },
      ]);

      dispatch(
        LocalStorageActions.setAuthorization({
          auth: true,
          authDate: Commons.DateFormating(new Date()),
          authType: "e",
        })
      );

      Commons.Storages("set", "userInfo", {
        userId: data.userInfo.userId,
        userName: data.userInfo.userNm,
      });

      setTimeout(() => {
        navigate("/");
      }, 100);
    } catch (e) {
      console.log("토큰 인증 오류: ", e);
      setError("토큰 인증에 실패했습니다: " + e.message);
      setTimeout(() => {
        navigate("/");
      }, 3000);
    } finally {
      setLoading(false);
    }
  };

  // 로딩 중일 때
  if (loading) {
    return (
      <div className='sign-in__wrapper'>
        <div className='text-center p-4'>
          <Loading />
          <p className='mt-3'>로그인 처리 중...</p>
        </div>
      </div>
    );
  }

  // 에러가 있을 때
  if (error) {
    return (
      <div className='sign-in__wrapper'>
        <div className='text-center p-4'>
          <Alert variant='danger'>
            <h5>로그인 오류</h5>
            <p>{error}</p>
            <p className='small'>잠시 후 메인 페이지로 이동합니다.</p>
          </Alert>
        </div>
      </div>
    );
  }

  // 기본 상태 (토큰 처리 중)
  return (
    <div className='sign-in__wrapper'>
      <div className='text-center p-4'>
        <h4>모바일 로그인</h4>
        <p>토큰을 확인하고 있습니다...</p>
      </div>
    </div>
  );
}

export default LoginMobile;
